import numeral from 'numeral';
import 'numeral/locales/es-es';

numeral.locale('es-es');

/**
 * Formates file size.
 *
 * @param {Number|String} size
 */
export const formatFileSize = (bytes, decimals) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals || 2;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  // eslint-disable-next-line no-restricted-properties
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

// Numbers format
const customFormat = val => (val.toString().indexOf('.') > -1 ? '0,0.00' : '0,0');
export const number = val => numeral(val).format(customFormat(val));
export const currency = val => numeral(val).format(`${customFormat(val)} $`);
export const taxPercent = val => numeral(val).format('0 %');

const UNITS = {
  BYTES: 1,
  KB: 1024,
  MB: 1024 ** 2, // 1024 * 1024
  GB: 1024 ** 3,
  TB: 1024 ** 4
};

/**
 * Convierte un valor de una unidad de almacenamiento de datos a otra.
 * @param {number} value - El valor a convertir.
 * @param {'BYTES'|'KB'|'MB'|'GB'|'TB'} fromUnit - La unidad original.
 * @param {'BYTES'|'KB'|'MB'|'GB'|'TB'} toUnit - La unidad a la que se quiere convertir.
 * @param {number} [decimals=2] - El número de decimales del resultado.
 * @returns {number} El valor convertido.
 */
export const convertUnits = (value, fromUnit, toUnit, decimals = 2) => {
  const normalizedFromUnit = fromUnit.toUpperCase();
  const normalizedToUnit = toUnit.toUpperCase();
  if (typeof value !== 'number' || !UNITS[normalizedFromUnit] || !UNITS[normalizedToUnit]) {
    return 0;
  }
  const valueInBytes = value * UNITS[normalizedFromUnit];
  const result = valueInBytes / UNITS[normalizedToUnit];
  return Number(result.toFixed(decimals));
};
